import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/terms-categories/new/loading';

export const Route = createFileRoute('/_private/settings/terms-categories/new')({
  component: Loading,
});
